// extracted by mini-css-extract-plugin
export var accordion = "_aq-0";
export var chevron = "_aq-3";
export var closed = "_aq-2";
export var content = "_aq-4";
export var open = "_aq-1";
export var rotate = "_aq-5";